import React, { useState, useEffect } from "react";

import Arrow from "./images/hint-arrow.svg";
import whiteX from "./images/white-x.svg";

import parse from "html-react-parser";
import { useTranslation } from "react-i18next";
import { default as i18n } from "@learningblocks/shared-components/lib/i18n";

import "./index.css";

export default function SSQuestion(props) {
  const {
    t,
    // i18n
  } = useTranslation("translation");

  const data = props.data;
  const options = props.data.options;
  const image = data.image;
  let correct = "";
  options.map((option) => {
    if (option.id === data.answerId) {
      correct = option.text;
    }
  });

  const [selected, setSelected] = useState(null);
  const [attempts, setAttempts] = useState(options.length);
  const [complete, setComplete] = useState(false);
  const [attempted, setAttempted] = useState([]);
  const [showHint, setShowHint] = useState(false);
  const [imgSrc, setImgSrc] = useState(
    props.preview
      ? data.imageURL
      : window.location.origin +
          window.location.pathname +
          `locales/${i18n.language}/images/${image}`
  );

  useEffect(() => {
    setSelected(null);
    setAttempts(options.length);
    setComplete(false);
    setAttempted([]);
    setShowHint(false);

    correct = "";
    options.map((option) => {
      if (option.id === data.answerId) {
        correct = option.text;
      }
    });
  }, [props.data]);

  const handleSubmit = () => {
    for (let i = 0; i < options.length; i++) {
      if (options[i].text === selected) {
        const updatedAttempted = attempted;
        updatedAttempted.push(options[i].text);
        setAttempted(updatedAttempted);
      }
    }
    if (selected === correct) {
      setComplete(true);
    }

    setAttempts(attempts - 1);
    setSelected(null);

    if (selected !== correct && attempts > 1) {
      const optionsContainer = document.querySelector("#options");
      if (optionsContainer) {
        optionsContainer.focus();
      }
    }
  };

  const renderOption = (option, key) => {
    const optionId = `option-${key}`;
    const letter = t(`${(key + 1 + 9).toString(36).toUpperCase()}.string`);
    return (
      <div key={key} className="option-container">
        <div
          className={`
          SSQoption option
          ${option.answer === options[key].text && selected === option.answer ? "selected" : ""} 
          ${attempted.includes(option.answer) ? "attempted" : ""} 
          ${option.answer === correct ? "correct" : "incorrect"} 
          ${attempts < 1 || complete ? "disabled" : ""}
        `}
          tabIndex="0"
          role="radio"
          aria-checked={selected === option.answer}
          aria-label={`${letter}: ${t(`${options[key].text}.string`)}`}
          id={optionId}
          onClick={() => {
            setSelected(option.answer);
          }}
          onKeyUp={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              setSelected(option.answer);
            }
          }}
          aria-disabled={attempts < 1 || complete}
        >
          <div
            className={`alphabet ${attempted.includes(option.answer) ? "attempted" : ""} ${option.answer === correct ? "correct" : "incorrect"}`}
          >
            {attempted.includes(option.answer) && option.answer === correct ? (
              <div>&#10004;</div>
            ) : attempted.includes(option.answer) &&
              option.answer !== correct ? (
              <img
                style={{ width: "20px" }}
                src={whiteX}
                alt=""
                role="presentation"
              />
            ) : (
              t(`${(key + 1 + 9).toString(36).toUpperCase()}.string`)
            )}
          </div>
          <div className={`option-answer`}>
            {parse(t(`${options[key].text}.string`))}
          </div>
        </div>
        <div
          className={`
          feedback ${option.answer === correct ? "correct" : "incorrect"} 
          ${attempted.includes(option.answer) ? "attempted" : ""}  
        `}
          role="alert"
          aria-live="polite"
          aria-atomic="true"
        >
          <p className="feedback-label">
            {t(`Feedback.string`)}
            <br />
            {parse(t(`${options[key].feedback}.string`))}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className="SSQuestion-container">
      <div
        className={`SSQuestion ${attempts === 0 || complete ? "complete" : ""}`}
        role="region"
        aria-labelledby="ssq-heading"
      >
        <div>
          <h2 className="question-header" id="ssq-heading">
            {t(`SSQ.string`)}
          </h2>
          <div className="question" id="ssq-question">
            {parse(t(`${data.question}.string`))}
          </div>
        </div>
        {image !== null && image !== "" ? (
          <div
            id="question-image-container"
            className="question-image-container"
          >
            <img
              id="question-image"
              className="question-image"
              style={{
                minHeight: props.preview && image !== "" ? "100px" : null,
              }}
              src={imgSrc}
              onError={() =>
                setImgSrc(
                  window.location.origin +
                    window.location.pathname +
                    `locales/en/images/${image}`
                )
              }
              alt={
                data.imageAlt !== ""
                  ? t(`${data.imageAlt}.string`)
                  : "Question illustration"
              }
            />
          </div>
        ) : null}
        <div
          id="options"
          tabIndex="-1"
          className="options"
          role="radiogroup"
          aria-labelledby="ssq-question"
        >
          {options.map((option, key) => {
            option = {
              answer: option.text,
            };
            return renderOption(option, key);
          })}
        </div>
        <div
          className="hint-container"
          tabIndex="0"
          role="button"
          onClick={() => {
            setShowHint(!showHint);
          }}
          onKeyUp={(e) => {
            if (e.key === "Enter") {
              setShowHint(!showHint);
            }
          }}
          style={{ display: data.hint === "" ? "none" : null }}
        >
          <div className="hint-toggle">
            {t("Hint.string")}
            <img
              className={`hint-arrow ${!showHint ? "hide" : ""}`}
              src={Arrow}
              alt={"Open, close arrow"}
            />
          </div>
          <div className={`hint ${!showHint ? "hide" : ""}`}>
            {parse(t(`${data.hint}.string`))}
          </div>
        </div>
        <div className="submit-container">
          <div id="attempts-text" className="attempts">
            {t(`AttemptsLeft.string`)}: {attempts}
          </div>
          <button
            className={`submit ${selected === null || attempts < 1 || complete ? "disabled" : ""}`}
            onClick={() => {
              handleSubmit();
            }}
            onKeyUp={(e) => {
              if (
                e.key === "Enter" &&
                selected !== null &&
                attempts > 0 &&
                !complete
              ) {
                handleSubmit();
              }
            }}
            disabled={selected === null || attempts < 1 || complete}
            aria-label={t(`SubmitAnswer.string`)}
          >
            {t(`SubmitAnswer.string`)}
          </button>
        </div>
      </div>
    </div>
  );
}
